module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS10.69b9358b.jpg";